import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  FormGroupDirective,
  FormGroup,
  FormControl,
  ControlContainer,
  Validators,
  FormBuilder,
} from '@angular/forms';

// thirdparty
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import {
  RecaptchaComponent,
  RecaptchaModule,
} from 'ng-recaptcha';

// services
import { AuthService } from '../../services/auth.service';
@Component({
    selector: 'app-recaptcha-form',
    templateUrl: './recaptcha-form.component.html',
    viewProviders: [{
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }],
    imports: [
      RecaptchaModule
    ]
})
export class RecaptchaFormComponent implements OnInit, OnDestroy, OnChanges {
  private parent = inject(FormGroupDirective, { optional: true });
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private isCaptchaRequired$ = toObservable(this.authService.isCaptchaRequired);

  readonly groupName = input<string>(undefined);
  readonly formInvalid = input<boolean>(undefined);
  @Input() showCaptcha: boolean;
  readonly reset = input<boolean>(undefined);
  readonly saved = output<boolean>();
  readonly captchaRef = viewChild<RecaptchaComponent>('captchaRef');

  form: FormGroup;
  formGroup: FormGroup;
  siteKey: string;
  unsubscriber$ = new Subject<void>();

  constructor() {
    const environment = inject<any>('environment' as any);

    this.siteKey = environment.siteKey;
  }

  ngOnInit() {
    if (this.parent && this.parent.form) {
      this.form = this.parent.form;
    } else {
      this.form = this.fb.group({});
    }
    const groupName = this.groupName();
    if (groupName) {
      this.formGroup = this.form.get(groupName) as  FormGroup;
    } else {
      this.formGroup = this.form;
    }
    this.formGroup.addControl('recaptcha', new FormControl('', Validators.required));
    if (!this.showCaptcha) {
      this.isCaptchaRequired$
      .pipe(
        delay(0),
        takeUntil(this.unsubscriber$)
      )
      .subscribe(response => {
        if (response) {
          this.showCaptcha = true;
          this.formGroup.get('recaptcha').enable();
        } else {
          this.showCaptcha = false;
          this.formGroup.get('recaptcha').disable();
        }
      });
    }
  }

  ngOnChanges() {
    if (this.reset()) {
      this.captchaRef().reset();
      this.formGroup.get('recaptcha').setValue('');
      this.formGroup.get('recaptcha').markAsUntouched();
      this.formGroup.get('recaptcha').markAsPristine();
      this.formGroup.get('recaptcha').updateValueAndValidity();
      this.formGroup.get('recaptcha').enable();
    }
  }

  ngOnDestroy() {
    this.unsubscriber$.next();
  }

  handleSuccess(token) {
    this.formGroup.get('recaptcha').setValue(token);
    const data = {
      token: token
    };
    this.authService.validateCaptcha(data).subscribe(response => {
      this.saved.emit(true);
    });
  }
}
